import React from "react";

const AnalyticsFilter = ({ startDate, endDate, handleDateChange, handleSubmit }) => {
  return (
    <form className="form-inline" onSubmit={handleSubmit}>
      <label htmlFor="startDate" className="mr-sm-2">
        Start Date:
      </label>
      <input
        type="date"
        value={startDate}
        className="form-control mb-2 mr-sm-2"
        placeholder="Start date"
        id="startDate"
        name="startDate"
        onChange={handleDateChange}
      />
      <label htmlFor="end_date" className="mr-sm-2">
        End Date:
      </label>
      <input
        type="date"
        className="form-control mb-2 mr-sm-2"
        value={endDate}
        placeholder="End date"
        id="endDate"
        name="endDate"
        onChange={handleDateChange}
      />
      <button type="submit" className="btn btn-primary mb-2 btn-sm">
        Fetch data
      </button>
    </form>
  );
};

export default AnalyticsFilter;
